import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { AppealService } from 'src/app/core/services/appeal.service';
import { map, Observable, firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-appeal-detail',
  templateUrl: './appeal-detail.component.html',
  styleUrls: ['./appeal-detail.component.css']
})
export class AppealDetailComponent implements OnInit {
  userDetails: any;
  isArabic!: boolean;
  @Input() enforcementList: any;
  userData: any;

  assessmentName = '';
  inspection = '';
  actionItems: any[] = [];
  appealId?: string;
  appealHistorical?: boolean;
  assessmentStatus?: number;
  actionItemStatus?: number;
  comments: string = ""
  isUnderReview = false; // flag to disable button
  appealTabs = ['Submission Guideline', 'Entity details', 'Appellant details', 'Appeal details', 'Authorized person signature'];
  activeAppealTab = 0;
  fetchedDocuments: any[] = [];
  showDocuments = false;
  formError: string | null = null;

  appealForm: any = {
    fullName: '',
    incorporationDate: '',
    licenseNumber: '',
    companyAddress: '',
    propertyName: '',
    designation: '',
    phone: '',
    mobile: '',
    email: '',
    address: '',
    submitDate: '',
    reason: '',
    violationType: null,
    violationDate: '',
    appealAmount: '',
    statement: '',
    evidenceList: '',
    authorizedName: '',
    authorizedDate: '',
    idNumber: '',
    signature: '',
    appealSubmittedFromRetrurn: ''
  };
  appealSubmitButtonEn = "Initiate Appeal";
  constructor(
    private router: Router,
    private storageService: StorageService,
    private commonService: CommonService,
    private appealService: AppealService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.userDetails = this.storageService.getSessionStorageData('userDetails');

    this.isArabic = this.storageService.getSessionStorageData('isArabic');
     this.appealTabs = this.getAppealTabs();

    this.appealHistorical = this.storageService.getSessionStorageData('appealHistorical');

    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state as { appealId?: string, appealHistorical?: boolean };

    this.appealId = state?.appealId ||
      history.state?.enforcementId ||
      this.storageService.getSessionStorageData('appealId');

    this.appealHistorical = state?.appealHistorical ||
      history.state?.appealHistorical ||
      this.storageService.getSessionStorageData('appealHistorical');

    const requestData = { appealId: this.appealId, appealHistorical: this.appealHistorical };

    let appealObservable;
    if (this.appealHistorical) {
      appealObservable = this.appealService.fetchAppealHistoricalDetail(requestData);
      this.fetchAppeal(appealObservable, 'historical');
    } else {
      appealObservable = this.appealService.fetchAppealDetail(requestData);
      this.fetchAppeal(appealObservable, 'initiate');
    }

  }

  private fetchAppeal(appealObservable: Observable<any>, tab: string) {

    appealObservable.subscribe({
      next: (res: any) => {
        const encrypted = res?.body?.data ?? res?.data ?? null;
        if (!encrypted) {
          console.warn('No encrypted data returned from API', res);
          return;
        }

        const decrypted = this.commonService.decryptUsingAES256(encrypted);
        const appealData = Array.isArray(decrypted) ? decrypted : [decrypted];
        let dataArray = [];
        if (tab == 'initiate') {
          dataArray = appealData?.filter((appeal: any) => (appeal.mde_appealstatus
            === 755020000 || appeal.mde_appealstatus
            === 755020006));
        } else {
          dataArray = appealData
        }
        if (dataArray.length) {
          const first = dataArray[0];
          this.assessmentName = first?.mde_assessmententity?.name ?? first?.mde_ActionPlan?.mde_AssessmentUnit?.name ?? '';
          this.inspection = first?.mde_inspection?.mde_name ?? first?.mde_ActionPlan?.mde_name ?? '';

          // map action items
          this.actionItems = dataArray.map((item: any, idx: number) => ({
            idx,
            appealTitle: item?.mde_name,
            title: item?.mde_actionitem?.mde_name ?? item?.mde_ActionPlan?.mde_name ?? item?.mde_name,
            violation: item?.mde_violation?.mde_name ?? item?.mde_violation?.mde_name,
            clauseNumber: item?.mde_clausenumberonactionitem,
            commentHistory: item?.mde_commenthistory,
            fine: Number(item?.mde_fineamount ?? item?.mde_Violations?.mde_1stwarningfines ?? 0),
            selected: false,
            reason: item?.mde_reasonforappeal ?? '',
            files: [] as File[],
            raw: item
          }));

          // ✅ Auto-select first item
          if (this.actionItems.length > 0) {
            this.actionItems[0].selected = true;
            this.prefillAppealFormFromRaw(this.actionItems[0].raw);
            this.setAppealReason();

            this.fetchDocuments(this.actionItems[0].raw);
          }
        }
      },
      error: (err) => {
        console.error('Error fetching fines detail', err);
      }
    });
  }

  private isoToDateInput(value: any): string {
    if (!value) return '';
    try {
      const d = new Date(value);
      if (isNaN(d.getTime())) return '';
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    } catch {
      return '';
    }
  }
  private fetchDocuments(item: any): void {
    this.fetchedDocuments = [];
    this.showDocuments = false;
    const appealItemId = item?.mde_appealid;

    if (!appealItemId) {
      console.warn('Appeal ID is missing for document fetch.');
      return;
    }

    // You will need to know the structure of the document API response
    this.appealService.fetchAppealDocuments(appealItemId).pipe(
      map((res: any) => {
        const encrypted = res?.body?.data ?? res?.data ?? null;
        if (!encrypted) return [];
        const decrypted = this.commonService.decryptUsingAES256(encrypted);
        // Assuming the decrypted data is an array of documents, e.g., [{ name: 'doc1', url: '...' }]
        return Array.isArray(decrypted) ? decrypted : [decrypted];
      })
    ).subscribe({
      next: (documents: any[]) => {
        this.fetchedDocuments = documents;
        // console.log('Fetched documents:', this.fetchedDocuments);
      },
      error: (err) => {
        console.error('Error fetching appeal documents', err);
        this.fetchedDocuments = [];
      }
    });
  }
  private prefillAppealFormFromRaw(raw: any) {
    if (!raw) return;
    // console.log('prefillAppealFormFromRaw reason:', this.appealForm.reason);

    this.appealForm.EntityName = raw?.mde_assessmententity?.name ?? raw?.mde_assessmententity?.name ?? '';
    this.appealForm.fullName = raw?.mde_appealantfullname ?? raw?.mde_appellantfullname ?? '';
    this.appealForm.incorporationDate = this.isoToDateInput(raw?.mde_incorporationdate);
    this.appealForm.licenseNumber = raw?.mde_licensenumber ?? '';
    this.appealForm.companyAddress = raw?.mde_companyaddress ?? '';
    this.appealForm.propertyName = raw?.mde_propertyname ?? '';
    this.appealForm.designation = raw?.mde_appealantdesignation ?? '';
    this.appealForm.phone = raw?.mde_phonenumber ?? '';
    this.appealForm.mobile = raw?.mde_mobilenumber ?? '';
    this.appealForm.email = raw?.mde_appealantemailaddress ?? '';
    this.appealForm.address = raw?.mde_appealantaddress ?? '';
    this.appealForm.submitDate = this.isoToDateInput(raw?.mde_appealsubmissiondate);
    // Only overwrite reason if current reason is empty or whitespace
    if (!this.appealForm.reason || this.appealForm.reason.trim() === '') {
      this.appealForm.reason = raw?.mde_reasonforappeal ?? '';
    }
    this.appealForm.violationType = raw?.mde_violationtype ?? null;
    this.appealForm.violationDate = this.isoToDateInput(raw?.mde_violationdate);
    this.appealForm.appealAmount = raw?.mde_appealamount ?? raw?.mde_fineamount ?? '';
    this.appealForm.statement = raw?.mde_appellantstatement ?? '';
    this.appealForm.evidenceList = raw?.mde_evidencesubmittedbyappellant ?? '';
    this.appealForm.authorizedName = raw?.mde_authorizedpersonfullname ?? '';
    this.appealForm.authorizedDate = this.isoToDateInput(raw?.mde_authorizedpersonsignaturedate);
    this.appealForm.idNumber = raw?.mde_authorizedpersonidnumber ?? '';
    this.appealForm.signature = raw?.mde_authorizedpersonsignature ?? '';
    if (raw?.mde_appealstatus === 755020006) {
      this.appealForm.appealSubmittedFromRetrurn = true;
      this.appealForm.mde_appealsubmissiondate = this.toUTC(new Date().toISOString())
    } else {
      this.appealForm.appealSubmittedFromRetrurn = false;
    }
  }

  // modified for single selection
  toggleSelect(item: any, event: Event): void {
    const input = event.target as HTMLInputElement;
    const checked = input.checked;
    this.formError = null;
    this.isUnderReview = false;
    this.appealSubmitButtonEn = "Initiate Appeal";
    // Unselect all items
    this.actionItems.forEach(i => i.selected = false);

    // Only the clicked one stays selected if checked
    item.selected = checked;

    if (checked) {
      this.prefillAppealFormFromRaw(item.raw);
      this.fetchDocuments(item.raw);
    } else {
      // fallback: reselect first if all unchecked
      if (!this.actionItems.some(i => i.selected) && this.actionItems.length > 0) {
        this.actionItems[0].selected = true;
        this.prefillAppealFormFromRaw(this.actionItems[0].raw);
        this.fetchDocuments(this.actionItems[0].raw);
      }
    }
  }

  get selectedCount(): number {
    return (this.actionItems || []).filter(i => !!i.selected).length;
  }

  onFileChange(event: Event, i: number): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      const selectedFiles = Array.from(input.files);

      const MAX_FILES = 10;
      const MAX_TOTAL_SIZE = 20 * 1024 * 1024; // 20 MB
      const allowedExtensions = ['pdf', 'jpeg'];

      const existingFiles = this.actionItems[i].files || [];

      // Validate ONLY newly selected files (extensions)
      const invalidFiles = selectedFiles.filter(file => {
        const ext = file.name.split('.').pop()?.toLowerCase() || '';
        return !allowedExtensions.includes(ext);
      });

      if (invalidFiles.length > 0) {
        input.value = '';
        return !this.isArabic
          ? alert(`These new files have invalid types: ${invalidFiles.map(f => f.name).join(', ')}`)
          : alert(`أنواع الملفات التالية غير مسموح بها: ${invalidFiles.map(f => f.name).join(', ')}`);
      }

      // Check total count (existing + new)
      const totalFileCount = existingFiles.length + selectedFiles.length;
      if (totalFileCount > MAX_FILES) {
        input.value = '';
        return !this.isArabic
          ? alert(`You can only upload up to ${MAX_FILES} files in total.`)
          : alert(`يمكنك تحميل ما يصل إلى ${MAX_FILES} ملفات إجمالاً.`);
      }

      // Check total size (existing + new)
      const combinedFiles = [...existingFiles, ...selectedFiles];
      const combinedTotalSize = combinedFiles.reduce((sum, file) => sum + file.size, 0);
      if (combinedTotalSize > MAX_TOTAL_SIZE) {
        input.value = '';
        return !this.isArabic
          ? alert('Total size of all files exceeds 20 MB. Please remove some files.')
          : alert('يتجاوز الحجم الإجمالي لجميع الملفات 20 ميجابايت. الرجاء إزالة بعض الملفات.');
      }

      // Passed all validations
      this.actionItems[i].files = combinedFiles;
      this.formError = null;

      // console.log(`Files after addition for item ${i}:`, this.actionItems[i].files);
    }
  }
  // onFileChange(event: Event, i: number): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files.length) {
  //     this.actionItems[i].files = Array.from(input.files);
  //     this.formError = null;
  //   } else {
  //     this.actionItems[i].files = [];
  //   }
  // }
onNext(): void {
  if (this.activeAppealTab < this.appealTabs.length - 1) this.activeAppealTab++;
}

onBack(): void {
  if (this.activeAppealTab > 0) this.activeAppealTab--;
}

  selectViolation(type: number) {
    this.appealForm.violationType = type;
  }

  async initiateAppeal(): Promise<void> {
    if (this.isSubmitDisabled()) {
      return;
    }
    // disable frontend submission under review
    if (!this.appealForm.violationType) {
      this.formError = 'Please select a violation type to continue.';
      return;
    }
    const selected = this.actionItems.find(i => i.selected);
    const selectedAppealId = selected?.raw?.mde_appealid ?? selected?.raw?.mde_appeal_id ?? this.appealId;
    // store assessment status and determine if under review
    this.assessmentStatus = selected?.raw?.mde_assessmentaccount?.mde_questionairestatus ?? null;
    this.actionItemStatus = selected?.raw?.mde_actionitem?.mde_actionitemstatus ?? null;
    const commentsRaw = selected?.raw?.mde_actionitem?.comments ?? null;
    const comments = commentsRaw && commentsRaw.trim() !== '' ? commentsRaw : null;

    let conversationHistory = selected.mde_commenthistory || '';
    const currentDate = new Date();

    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = currentDate.getFullYear();

    const dateString = `${day}.${month}.${year}`;
    // console.log(dateString);

    if (comments) {
      let userComment = `${this.userDetails?.firstname} ${this.userDetails?.lastname} - ${dateString} : ${comments}`;

      conversationHistory = conversationHistory ?
        conversationHistory + '\n' + userComment :
        userComment;
    }

    // Now conversationHistory only updated if comments not empty

    const disallowedAssessmentStatuses = [755020000, 755020013];
    const allowedActionItemStatuses = [755020002, 755020004, 755020006];

    const isAssessmentStatusDisallowed = disallowedAssessmentStatuses.includes(this.assessmentStatus ?? 0);
    const isActionItemInAllowedStatus = allowedActionItemStatuses.includes(this.actionItemStatus ?? 0);

    if (isAssessmentStatusDisallowed) {
      this.formError = "Assessment is in Progress. Appeal cannot be initiated.";
      return;
    }

    if (!isActionItemInAllowedStatus) {
      this.formError = "Action Item is in Pending. Appeal cannot be initiated.";
      return;
    }



    if (!selected) {
      this.formError = "Please select an action to appeal.";
      return;
    }
    try {
      await this.uploadFilesForAppeal()

      if (!selected.files || selected.files.length === 0) {
        this.formError = this.isArabic ? 'يرجى إرفاق المستندات قبل تقديم الاستئناف.' : 'Please attach documents before submitting the appeal.';
        return;
      }

      const payload = {
        mde_fineamount: selected.fine?.toString() ?? '',
        mde_waivedoffamount: '',
        mde_incorporationdate: this.toUTC(this.appealForm.incorporationDate),
        mde_licensenumber: this.appealForm.licenseNumber,
        mde_companyaddress: this.appealForm.companyAddress,
        mde_propertyname: this.appealForm.propertyName,
        mde_appealantfullname: this.appealForm.fullName,
        mde_appealantdesignation: this.appealForm.designation,
        mde_phonenumber: this.appealForm.phone,
        mde_mobilenumber: this.appealForm.mobile,
        mde_appealantemailaddress: this.appealForm.email,
        mde_appealantaddress: this.appealForm.address,
        //mde_appealsubmissiondate: this.toUTC(this.appealForm.submitDate),
        mde_appealsubmissiondate: this.toUTC(new Date().toISOString()),
        mde_reasonforappeal: this.appealForm.reason,
        mde_violationtype: this.appealForm.violationType,
        mde_violationdate: this.toUTC(this.appealForm.violationDate),
        mde_appellantstatement: this.appealForm.statement,
        mde_evidencesubmittedbyappellant: this.appealForm.evidenceList,
        mde_authorizedpersonfullname: this.appealForm.authorizedName,
        mde_authorizedpersonidnumber: this.appealForm.idNumber,
        mde_authorizedpersonsignature: this.appealForm.signature,
        mde_authorizedpersonsignaturedate: this.toUTC(this.appealForm.authorizedDate),
        mde_appealsubmittedfromretrurn: this.appealForm.appealSubmittedFromRetrurn,
        mde_commenthistory: conversationHistory
      };

      this.appealService.submitAppeal(payload, this.assessmentStatus, selectedAppealId)
        .subscribe({
          next: (res) => {
            if (res?.error != null) {
              this.appealSubmitButtonEn = "Initiate Appeal";
              this.formError = res.error;
              return;
            }
            this.appealSubmitButtonEn = "Appeal Submitted";
            // const requestData = { appealId: this.appealId, appealHistorical: this.appealHistorical };
            // let appealObservable = this.appealService.fetchAppealDetail(requestData);
            // this.fetchAppeal(appealObservable, 'initiate');
            this.router.navigate(['/executor-dashboard/appeal/historical'], {});
            //this.UpdateAppealCount()
          },
          error: (err) => {
            this.appealSubmitButtonEn = "Initiate Appeal";
            this.formError = err?.body?.error ||
              err?.message
            'Submission failed. Please try again.';
          }
        });
    } catch (error) {
      console.error('Appeal initiation failed:', error);
      this.formError = 'Submission failed. Please try again.'
      this.appealSubmitButtonEn = "Initiate Appeal";
    }
  }
  UpdateAppealCount() {
    // console.log('update appeal count called')
    this.userData = this.storageService.getSessionStorageData('userDetails');
    const requestData = {
      assessmentUnitGuid: this.userData?.assessmentUnitValue,
    };
    this.appealService.fetchAppealList(requestData).subscribe((res) => {
      if (res?.data) {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        let appealList = resp;
        // console.log('appealCount', appealList.length)
        if (appealList.length > 0) {
          this.storageService.setSessionStorageData('appealCount', appealList.length);
        } else {
          this.storageService.setSessionStorageData('appealCount', 0)
        }
      }
    },
      (error: any) => {
        console.error('Error fetching appeal list', error);
      });
  }
  private toUTC(date: string): string | null {
    if (!date) return null;
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString();
  }
  isUploading = false;
  uploadProgress = 0;

  // Show popup and reset progress
  showUploadPopup() {
    const overlay = document.querySelector('.upload-overlay') as HTMLElement;

    const popup = document.getElementById('uploadPopup');
    const progressBar = document.getElementById('uploadProgressBar') as HTMLProgressElement;
    const progressPercent = document.getElementById('progressPercent');

    if (popup && progressBar && progressPercent) {
      popup.style.display = 'block';
      progressBar.value = 0;
      progressPercent.textContent = '0%';
    }
    if (overlay) overlay.style.display = 'block';

  }

  // Update progress
  updateUploadProgress(percent: number) {
    // console.log('updateUploadProgress called with percent:', percent);  // <-- DEBUG 

    const progressBar = document.getElementById('uploadProgressBar') as HTMLProgressElement;
    const progressPercent = document.getElementById('progressPercent');


    if (progressBar && progressPercent) {
      progressBar.value = percent;
      progressPercent.textContent = `${percent}%`;
      this.cd.detectChanges();

    }
  }

  // Hide popup
  hideUploadPopup() {
    const popup = document.getElementById('uploadPopup');
    if (popup) {
      popup.style.display = 'none';
    }
    const overlay = document.querySelector('.upload-overlay') as HTMLElement;
    if (overlay) overlay.style.display = 'none';
  }

  async uploadFilesForAppeal(): Promise<void> {
    const selected = this.actionItems.find((i) => i.selected);
    const hasFetchedDocs = this.fetchedDocuments && this.fetchedDocuments.length > 0;

    if (!selected && !hasFetchedDocs) {
      return !this.isArabic ? alert('Please select an action or upload documents for.') : alert("يرجى إرفاق المستندات الداعمة قبل المتابعة.");
    }

    const appealId = selected?.raw?.mde_appealid ?? selected?.raw?.mde_appeal_id ?? this.appealId;

    if (!appealId) {
      // console.log('Appeal ID is missing.');
      return;
    }

    // Convert to array if needed
    const uploadedFiles = selected?.files ? (Array.isArray(selected.files) ? selected.files : Array.from(selected.files)) : [];
    const hasUploadedFiles = uploadedFiles.length > 0;

    if (!hasUploadedFiles && !hasFetchedDocs) {
      return !this.isArabic ? alert('Please attach supporting document(s) before proceeding.') : alert("يرجى إرفاق المستندات الداعمة قبل المتابعة.");

    }

    if (hasUploadedFiles) {
      try {
        const base64Files = await Promise.all(
          uploadedFiles.map((file: File) => this.convertToBase64(file))
        );

        this.showUploadPopup();
        this.updateUploadProgress(0);

        const totalFiles = uploadedFiles.length;
        let uploadedFilesCount = 0;

        for (let i = 0; i < uploadedFiles.length; i++) {
          const file = uploadedFiles[i];
          const base64 = base64Files[i];

          const filesToSend = [{
            fileName: file.name,
            base64: base64
          }];

          // Await each upload sequentially
          await firstValueFrom(this.appealService.uploadAppealDocuments(filesToSend, appealId));

          uploadedFilesCount++;
          const percentComplete = Math.round((uploadedFilesCount / totalFiles) * 100);
          this.updateUploadProgress(percentComplete);
        }

        this.hideUploadPopup();
        // alert('Documents uploaded successfully!');

      } catch (err: any) {
        console.error('File upload failed:', err);
        this.hideUploadPopup();
        alert(err?.error?.error || 'File upload failed.');
      }
    } else if (hasFetchedDocs) {
      // console.log('Using fetched documents; no upload needed.', this.fetchDocuments);
      selected.files = this.fetchDocuments;
      // further logic here
    }
  }

  //Converts File to Base64 string (without "data:" prefix)
  private convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        const base64String = result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = (error: any) => reject(error);
      reader.readAsDataURL(file);
    });
  }
  public toggleDocuments(): void {
    this.showDocuments = !this.showDocuments;
  }
  // Call this method after you get or update actionItems or appealForm.reason
  setAppealReason() {
    if (this.appealForm.reason && this.appealForm.reason.trim() !== '') {
      // console.log('setAppealReason: reason already set:', this.appealForm.reason);
      return;
    }
    if (this.actionItems.length > 0) {
      const item = this.actionItems[0];
      // console.log('setAppealReason: examining item:', item);
      const fallbackReason =
        item.violation ||
        item.title ||
        item.appealTitle ||
        '<No Reason Available>';
      this.appealForm.reason = fallbackReason;
      // console.log('setAppealReason: fallback reason:', fallbackReason);
      this.appealForm.reason = fallbackReason;
    } else {
      this.appealForm.reason = '';
    }
  }
  validateDocuments(item: any): boolean {
    // If files uploaded or fetched documents exist, it's valid
    if (
      (item.files && item.files.length > 0) ||
      (this.fetchedDocuments && this.fetchedDocuments.length > 0)
    ) {
      return true; // valid
    } else {
      return false; // invalid, show error
    }
  }

  private requiredFieldsPerTab: any = {
    2: ['mobile', 'email', 'address'],
    3: ['statement', 'evidenceList']
  };
  isSubmitDisabled(): boolean {
    const allRequiredFields = Object.values(this.requiredFieldsPerTab).flat();

    return allRequiredFields.some((field: any) => {
      const val = this.appealForm[field];

      if (val === null || val === undefined) return true;
      if (typeof val === 'string' && val.trim() === '') return true;

      return false;
    });
  }
  isFieldInvalid(field: string): boolean {
    const requiredFields = this.requiredFieldsPerTab[this.activeAppealTab];

    return requiredFields ? requiredFields.includes(field) && !this.appealForm[field] : false;
  }

  // Comment handling
  onCommentChange(event: any, idx: number) {
    const value = (event.target && event.target.value) || event;
    this.actionItems[idx].comments = value;
  }

  onKeyup(event: any, idx: number) {
    const value = (event.target && event.target.value) || '';
    this.checkError(this.actionItems[idx], value);
  }
  checkError(item: any, value: string) {
    item.showError = !(value && value.length > 0);
  }
  sanitizeComment(comment: string): string {
    if (!comment || comment.toLowerCase() === 'null') {
      return 'No comments';
    }
    return comment;
  }
  onDeleteNewFile(i: number, fi: number) {
    const actionitem = this.actionItems[i];
    if (!actionitem?.files) return;

    actionitem.files.splice(fi, 1);

    // Trigger change detection with new array references if needed
    actionitem.attachedFiles = [...actionitem.attachedFiles];
  }
  getAppealTabs(): string[] {
  const tabs = this.isArabic
    ? [
        'إرشادات تقديم الطلب',
        'بيانات المنشأة',
        'بيانات مقدم التظلم',
        'تفاصيل التظلم',
        'توقيع الشخص المفوض'
      ]
    : [
        'Submission Guideline',
        'Entity Details',
        'Appellant Details',
        'Appeal Details',
        'Authorized Person Signature'
      ];

  if (this.isArabic) {
    return tabs.slice().reverse(); // return reversed copy for Arabic
  }

  return tabs;
}
}
